export const ERROR_MESSAGES = {
  UNSUPPORTED_FILENAME: "File name contains unsupported characters.",
  INVALID_PDF_CONTENT: "Invalid or harmful file detected.",
  PDF_VALIDATION_ERROR: "Error validating PDF content.",
  ZERO_BYTE_FILE: "Can't upload zero byte file",
  INVALID_FILE_TYPE: "Upload Only Image or PDF",
  FILE_SIZE_EXCEEDED: "File Size is beyond 50MB",
  NO_BANK_DOCUMENT: "Please upload bank document",
  DOCUMENT_UPLOAD_FAILED: "Failed to upload document.",
  BANK_ACCOUNT_ADD_FAILED: "Failed to add bank account. Please check your details and try again.",
};
